import React, { useContext, useState, useEffect } from "react";
import { useTable } from "react-table";
import { StyledTablePage } from "../../styled-components/StyledTablePage.style";
import { StyledForm } from "../../styled-components/StyledForm.style";
import { Table } from "../TableRows";
import { IconMenuDotsV } from "../../svg";
import Modal from 'react-modal';
import Flex from '@react-css/flex';



export const TableFormAtividadeList = ({ columns, data, atividades, peritos, isOpen, onAfterOpen, onRequestClose, isFromProjetoInterno }) => {
    const {
        getTableProps, // table props from react-table
        getTableBodyProps, // table body props from react-table
        headerGroups, // headerGroups, if your table has groupings
        rows, // rows for the table based on the data passed
        prepareRow // Prepare the row (this function needs to be called for each row before getting the row props)
    } = useTable({
        columns,
        data,
        isFromProjetoInterno
    });
    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '35%',
            overflowY: 'auto',
            minHeight: '55%',
            maxHeight: '90%'
        },
        overlay: {
            zIndex: 9999
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={onRequestClose}
            contentLabel="Timesheet Atividades"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledForm>
                <p className="modal-close" onClick={onRequestClose}>X</p>
            </StyledForm>
            <StyledForm>
                <StyledTablePage>
                    <Flex>
                        <Flex.Item className="modal-width">
                            <div className="position-relative form-group">
                                <p className="modal-title">Nova Atividade</p>
                            </div>
                        </Flex.Item>
                    </Flex>
                    <Table atividades={atividades} peritos={peritos} isFromProjetoInterno={isFromProjetoInterno} />
                </StyledTablePage>
            </StyledForm>
        </Modal>
    );
};
